var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageLayout } from '../../Components/PageLayout';
import { WarningIcon } from './WarningIcon';
import styled from 'styled-components';
import { MainText, Text } from '../../Components/BaseComponents/Typography';
import { useTransactionType } from '../../hooks/useSignalTransaction';
import { storage } from '../../../Services/storage';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 64px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 64px;\n"])));
var Title = styled(MainText)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 32px;\n"], ["\n  margin-top: 32px;\n"])));
var Description = styled(Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: center;\n  margin-top: 16px;\n  color: ", ";\n"], ["\n  text-align: center;\n  margin-top: 16px;\n  color: ", ";\n"])), function (props) { return props.theme.colors.textBodyAdd; });
export var PreconditionFailedPage = function (_a) {
    var failureMessage = _a.failureMessage;
    var type = useTransactionType();
    var reloadApp = function () {
        storage.clearAll();
        window.location.reload();
    };
    return (_jsx(PageLayout, __assign({ footer: {
            actionButtonLabel: type === 'multi' ? 'Create new order' : undefined,
            buttonClick: reloadApp,
        }, hideBackArrow: true, hideHeaderChip: true }, { children: _jsxs(Wrapper, { children: [_jsx(WarningIcon, {}), _jsx(Title, __assign({ style: { marginTop: 32 } }, { children: "Oops!" })), _jsx(Description, { children: failureMessage })] }) })));
};
var templateObject_1, templateObject_2, templateObject_3;
